import apiApp from "./callApp"
/**
 * loading
 * @param {Boolean} flag 是否显示loading
 * @param {String} text 加载文案
 * @param {Number} duration 加载时间，0时候web端控制显示隐藏，不为零app端控制显示隐藏
 */
 function nativeLoading(flag,text,duration){
    const showReq ={
        params:{
              flag,
              text,
              duration,
           },
        callbackfunc:"",
     }
  apiApp.callApp("Native", "nativeLoading",showReq)
 }

/**
 * 关闭web页面 开通服务 跳转到 换到换电中心页面
 */
function finishCabinetWeb(){
    const req = { params: {}, callbackfunc: "" }
    apiApp.callApp("Native", "finishCabinetWeb",req)
}

/**
 * api请求错误 app统一处理，token过期,错误提示 
 * @param {String} state 状态码
 * @param {String} state_info 状态信息
 */
function checkError(state,state_info){
    const req = {
        params:{
            state,
            state_info,
        },
        callbackfunc:""
    }
    apiApp.callApp("Native", "checkError",req)
}

 export default {
    nativeLoading,
    finishCabinetWeb,
    checkError,
 }


// WEBPACK FOOTER //
// ./src/utils/appApi.js